import * as yup from 'yup';

export const inviteMerchantSchema = yup.object({
	email: yup.string().email().required(),
});
